var formHelpers = {};
formHelpers.install = function(app, options){
  var common = {
    methods: {
      findParentForm() {
        if(this.$data.fname || this.$props.fname)
          return this.$data.fname || this.$props.fname;
        else
          return this.$parent && this.$parent.findParentForm && this.$parent.findParentForm();
      }
    }
  }
  app.mixin(common);
}

export default formHelpers;